var $c96a9b1bbbeabfae$exports = {};
$c96a9b1bbbeabfae$exports = {
    "info": `Informazioni`,
    "negative": `Errore`,
    "positive": `Operazione riuscita`
};


export {$c96a9b1bbbeabfae$exports as default};
//# sourceMappingURL=it-IT.mjs.map
